import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
export const BaseTabPanel = (props) => {
    const { activeValue = undefined, children, className = '', value } = props;
    // active 判定
    const active = activeValue === value;
    return (_jsx("div", Object.assign({ className: clsx('w-full', active ? 'block' : 'hidden', className) }, { children: children })));
};
